<div [formGroup]="form">
    <mat-form-field appearance="outline" class="category-field">
        <mat-icon matPrefix>grid_view</mat-icon>
        <mat-label>{{'reserve.manual.form.category'|traduccion}}</mat-label>
        <mat-select formControlName="selectedCategoryItem">
            <mat-option *ngFor="let cat of flatCategories"
                        [value]="cat"
                        [disabled]="cat.expandable">
                <span [style.padding-left.px]="cat.level * 16">
                    {{cat.name}}
                </span>
            </mat-option>
        </mat-select>
        <app-form-error [control]="form.get('selectedCategoryItem')" ></app-form-error>
    </mat-form-field>
</div>

